// SPDX-License-Identifier: AGPL-3.0-or-later

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';

export const TextChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(({size = 256, className, ...props}, ref) => (
	<svg
		ref={ref}
		width={size}
		height={size}
		viewBox="0 0 256 256"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden={true}
		data-flx="ui.icons.text-channel-icon.svg"
		{...props}
	>
		<path
			fill="currentColor"
			d="M128 24C68.4 24 20 65.2 20 116c0 29.5 16.3 56.8 44 74.5V220a12 12 0 0 0 18.7 10l29.6-19.8c5.2.8 10.4 1.2 15.7 1.2 59.6 0 108-41.2 108-95.4S187.6 24 128 24Zm-52 80h104a10 10 0 0 1 0 20H76a10 10 0 0 1 0-20Zm0 38h68a10 10 0 0 1 0 20H76a10 10 0 0 1 0-20Z"
			data-flx="ui.icons.text-channel-icon.path"
		/>
	</svg>
));
